import i18next from 'i18next';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { GLOBAL_ERROR_CODE } from '~graphql-types';
import { displayErrorToast } from '~reducers/toast/action';

function useHandleError(error, disabled, callback) {
  const dispatch = useDispatch();
  const disabledType = useMemo(() => {
    return Array.isArray(disabled) ? disabled : [disabled];
  }, [disabled]);

  useEffect(() => {
    if (error) {
      const { networkError, graphQLErrors } = error;
      if (graphQLErrors?.length > 0) {
        // Global error will be handled in apollo client
        if (Object.values(GLOBAL_ERROR_CODE).includes(graphQLErrors[0].code)) {
          return;
        }
        if (
          disabledType.some((item) => item === graphQLErrors[0].message) &&
          typeof callback === 'function'
        ) {
          callback(graphQLErrors[0].message);
          return;
        }
        const toast = i18next.t(`toast.error.${graphQLErrors[0].message}`);
        dispatch(
          displayErrorToast(toast.indexOf('toast.error') < 0 ? toast : graphQLErrors[0].message)
        );
        return;
      }
      if (networkError) {
        dispatch(displayErrorToast(networkError.message));
        return;
      }
      dispatch(displayErrorToast(error.message));
    }
  }, [dispatch, error, disabledType, callback]);
}

export default useHandleError;

export function useAsyncHandleError() {
  const dispatch = useDispatch();
  return useCallback(
    (error) => {
      if (error) {
        const { networkError, graphQLErrors } = error;
        if (graphQLErrors?.length > 0) {
          // Global error will be handled in apollo client
          if (Object.values(GLOBAL_ERROR_CODE).includes(graphQLErrors[0].code)) {
            return;
          }
          const toast = i18next.t(`toast.error.${graphQLErrors[0].message}`);
          dispatch(
            displayErrorToast(toast.indexOf('toast.error') < 0 ? toast : graphQLErrors[0].message)
          );
          return;
        }
        if (networkError) {
          dispatch(displayErrorToast(networkError.message));
          return;
        }
        dispatch(displayErrorToast(error.message));
      }
    },
    [dispatch]
  );
}
